import { ChevronSmallDownIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiSelectOverrides = {
  MuiSelect: {
    defaultProps: {
      variant: 'standard',
      IconComponent: props => /*#__PURE__*/jsx(ChevronSmallDownIcon, {
        ...props,
        cursor: "pointer",
        fontSize: "medium"
      })
    },
    styleOverrides: {
      standard: ({
        theme
      }) => ({
        '&.MuiSelect-select': {
          padding: theme.spacing(1.25, 4.5, 1.25, 1.5)
        }
      }),
      iconStandard: ({
        theme
      }) => ({
        marginRight: theme.spacing(1),
        color: theme.palette.blue80
      })
    }
  },
  MuiNativeSelect: {
    styleOverrides: {
      select: {
        lineHeight: 1.5
      },
      standard: ({
        theme
      }) => ({
        '&.MuiNativeSelect-select': {
          padding: theme.spacing(1, 4.5, 1, 1.5)
        }
      }),
      iconStandard: ({
        theme
      }) => ({
        marginRight: theme.spacing(1),
        color: theme.palette.blue80
      })
    }
  }
};

export { MuiSelectOverrides };
